import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import TopSearch from './TopSearch'
import DialogPopup from 'components/molecules/DialogPopup';
import PopupSyllabus from '../workspace/PopupSyllabus';
import PopupGames from '../workspace/PopupGames';
import PopupResources from '../workspace/PopupResources';

import flowerWhite from 'assets/images/flower-white.png';
import flowerYellow from 'assets/images/flower-yellow.png';
import flowerGray from 'assets/images/flower-gray.png';
import { RootState } from 'redux/store';
import { useSelector } from 'react-redux';
import AudioHeading from './AudioHeading';

import soundFromMyTeacher from 'assets/sound/from-my-teacher.mp3';
import soundMyScheduleToday from 'assets/sound/my-schedule-today.mp3';
import soundMyWork from 'assets/sound/my-work.mp3';
import soundMyHomeWork from 'assets/sound/my-homework.mp3';
import soundMyGames from 'assets/sound/my-games.mp3';
import soundMyPrintables from 'assets/sound/my-printables.mp3';


import beeAbc from 'assets/images/bee-abc.png';
import beeDiploma from 'assets/images/bee-diploma.png';
import beeLaptop from 'assets/images/bee-laptop.png';
import beeNotebook from 'assets/images/bee-notebook.png';
import beeBook from 'assets/images/bee-book.png';
import beeGlasses from 'assets/images/bee-glasses.png';
import iconTeachers from 'assets/images/icon-teachers.png';
import { PRIMARY_TRANSPARENT_GREEN } from 'utils/customizedTheme';
import { Avatar, Grid, Link } from '@mui/material';
import SectionGames from './SectionGames';
import SectionActivities from './SectionActivities';
import SectionPrintables from './SectionPrintables';
import SectionSubjects from './SectionSubjects';
import SectionMyWork from './SectionMyWork';
import SectionTarget from './SectionTarget';
import Assignments from './Assignments';
import AvatarInParts from './AvatarInParts';


const WorkspaceSmall: FC = () => {
  const { t } = useTranslation()

  const [popup, setPopup] = useState(null)
  const [popupTitle, setPopupTitle] = useState(null)

  const [topSearch, setTopSearch] = useState(null)
  
  const user = useSelector((state: RootState) => state['user'].user)

 
  return (
      <>
        <div className="blue-gradiant">
            <div className="container">

                <div className="small-student-top-tabs">

                    <div className="small-student-top-tab" 
                        onClick={() => {
                            setPopupTitle(t('common.curriculum'))
                            setPopup('syllabus')
                        }}>
                        <img src={beeAbc} />
                        <div className="small-student-top-tab-title">{t('common.curriculum')}</div>
                        <div className="flower flower-1" style={{ backgroundImage: `url(${flowerYellow})` }} />
                    </div>
                    <div className="small-student-top-tab"
                        onClick={() => {
                            setPopupTitle(t('goalbank.resources'))
                            setPopup('resources')
                        }}>
                        <img src={beeDiploma} />    
                        <div className="small-student-top-tab-title">{t('goalbank.resources')}</div>
                        <div className="flower flower-2" style={{ backgroundImage: `url(${flowerWhite})`}} />
                    </div>

                    <div className="small-student-top-tab"
                        onClick={() => {
                            setPopupTitle(t('dashboard.game-zone'))
                            setPopup('games')
                        }}
                    >
                        <img src={beeLaptop} />
                        <div className="small-student-top-tab-title">{t('dashboard.game-zone')}</div>
                        <div className="flower flower-3" style={{ backgroundImage: `url(${flowerGray})`}} />
                        <div className="flower flower-4" style={{ backgroundImage: `url(${flowerGray})`}} />
                    </div>

                    
                </div>

                <div style={{ height: '40px' }} />

                <TopSearch handleSearch={(qry) => {
                    setPopupTitle(t('goalbank.resources'))
                    setTopSearch(qry)
                    setPopup('resources')
                }} />



                {user && <div className='workspace-avatar'>


                    {user?.student_profile?.avatar && user.student_profile?.avatar_parts && 
                    <AvatarInParts parts={user.student_profile.avatar_parts}/>
                    }  

                {!user?.student_profile?.avatar &&
                    <Avatar
                          className='avatar'
                          sx={{
                            bgcolor: PRIMARY_TRANSPARENT_GREEN,
                            width: 100,
                            height: 100,
                            marginLeft: '20px',
                            marginRight: '20px',   
                            display: 'inline-block',
                            position: 'relative',
                            lineHeight: '70px',
                            textAlign: 'center'
                          }}
                          variant='circular'
                          src={user.student_profile?.avatar}
                        /> }

                    <div className='workspace-avatar-title'>
                        {t('dashboard.workspace-hello',{name: user.first_name})}
                    </div>
                </div>}
            </div>
        </div>


        <div className="green-gradiant">
            <div className="container">
                    <AudioHeading 
                        icon={iconTeachers}
                        audio={soundFromMyTeacher}
                        title={t('dashboard.from-my-teacher')} 
                        hint={t('dashboard.from-my-teacher-hint')}/>

                    <SectionActivities />
            </div>
        </div>


        <div className="container">
            <AudioHeading 
                icon={beeNotebook}
                audio={soundMyWork}
                title={t('dashboard.my-work')} 
                hint={t('dashboard.my-work-hint')}/>

            <SectionMyWork />   
        </div>

        <div className="container">
            <AudioHeading 
                icon={beeBook}
                audio={soundMyHomeWork}
                title={t('dashboard.my-homework')} 
                />


            <Grid container spacing={4}>
                <Grid item xs={12} lg={7}>
                    <Assignments /> 
                </Grid>
                <Grid item xs={12} lg={5}>
                    <SectionTarget />   
                </Grid>
            </Grid>
        </div>


        <div className="container">
            <AudioHeading 
                icon={beeDiploma}
                audio={soundMyScheduleToday}
                title={t('dashboard.my-schedule-today')} 
                />

            <SectionSubjects />
        </div>

        <div className="container">
            <AudioHeading 
                icon={beeLaptop}
                audio={soundMyGames}
                title={t('dashboard.my-games')} 
                />

            <SectionGames iframe={false} />
            <div style={{marginTop: '20px'}}  >
                <Link className='setup-link' onClick={() => {
                    setPopupTitle(t('dashboard.game-zone'))
                    setPopup('games')
                }}>{t('common.see-all')}</Link>
            </div>
                        
        </div>

        <div className="container">
            <AudioHeading 
                icon={beeGlasses}
                audio={soundMyPrintables}
                title={t('dashboard.my-printables')} 
                />

            <SectionPrintables />
            <div style={{marginTop: '20px'}} >
                <Link className='setup-link' style={{marginTop: '20px'}}  onClick={() => {
                    setPopupTitle(t('goalbank.resources'))
                    setPopup('resources')
                    }}>{t('common.see-all')}</Link>
            </div>
        </div>

 

        <DialogPopup
            title={popupTitle}
            open={!!popup}
            onClose={() => setPopup(null)}
            fullScreen={popup === 'games'}
            popupWidth={'1400px'}
        >
           <>
            {popup === 'syllabus' && <PopupSyllabus />}
            {popup === 'games' && <PopupGames />}
            {popup === 'resources' && user && <PopupResources qry={topSearch} initialGradeLevel={user?.grade_level} />}
           </>
        </DialogPopup>
      
      </>
  )
}

export default WorkspaceSmall
